import { isHTMLElementNode } from '../../serialization/helpers/serializerHelpers';

export const availableColors = ['gray', 'blue', 'green', 'yellow', 'red'];
export const DEFAULT_COLOR_SCHEME = 'gray';

export const LABEL_DEPRECATED_PILL_CLASS = 'aha-editor-v2__labelPill';
export const LABEL_DEPRECATED_PILL_CLASS_PREFIX = 'aha-editor-v2__labelPill--';

export const LABEL_V1_PILL_CLASS = 'labelPill';
export const LABEL_V1_PILL_CLASS_PREFIX = 'labelPill__';

export function isLabelPillNode(el: Node): el is HTMLSpanElement {
  return (
    isHTMLElementNode(el) &&
    el.tagName.toLowerCase() === 'span' &&
    (el.classList.contains(LABEL_DEPRECATED_PILL_CLASS) ||
      el.classList.contains(LABEL_V1_PILL_CLASS))
  );
}

export const sanitizeLabelPillColor = (color: string): string => {
  return availableColors.includes(color) ? color : DEFAULT_COLOR_SCHEME;
};
